/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const AngleUpSmall: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M10.2929 10.7071C10.6834 11.0976 11.3166 11.0976 11.7071 10.7071C12.0976 10.3166 12.0976 9.68342 11.7071 9.29289L8.70711 6.29289C8.31658 5.90237 7.68342 5.90237 7.29289 6.29289L4.29289 9.29289C3.90237 9.68342 3.90237 10.3166 4.29289 10.7071C4.68342 11.0976 5.31658 11.0976 5.70711 10.7071L8 8.41421L10.2929 10.7071Z' />
		</Svg>
	);
};

export { AngleUpSmall };
